import { cookiesAcceptedEvent, CookieStatus, getCookieStatus, setCookie } from "../custom/cookie_utils"
import { DataLayer } from "../datalayer"
import { gtag, defaultContent, fullContent, FullConsentUpdate } from "../datalayer.consent"



export const acceptCookies = () => {
  gtag('consent', 'update', fullContent);
  // Fire datalayer
  DataLayer.acceptCookies()

  // Set cookie to accepted
  setCookie('cookies', 'accepted', 30)

  // reload page
  window.location.reload()
}

export const rejectCookies = (currentStatus: CookieStatus) => {
  gtag('consent', 'update', defaultContent);

  // fire datalayer
  DataLayer.rejectCookies()

  // set cookies to rejected
  setCookie('cookies', 'rejected', 30)

  // reload
  window.location.reload()
}

/**
 * Update the initial consent for Google consent mode v2
 */
export function updateInitialConsent () {
  const currentCookieStatus = getCookieStatus()
  var data: FullConsentUpdate = defaultContent
  if (currentCookieStatus == 'accepted') {
    data = fullContent
  }

  gtag('consent', 'update', data);
}

window.updateInitialConsent = updateInitialConsent
